import { postMessageToChild } from './infrastructure.js';
export function postGenericMessage(microFrontName, data) {
    postMessageToChild(microFrontName, data);
}
//# sourceMappingURL=messages.js.map